import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import MetricsEditBaseRoute from 'webapp/routes/metrics/edit/base';

import type { HorizonMetric } from 'webapp/models-custom';

export default class MetricsEditHorizonRoute extends MetricsEditBaseRoute<HorizonMetric> {
	@service('model-manager/horizon-metrics')
	declare mmHorizonMetricsService: Service.ModelManager.HorizonMetrics;

	protected readonly notFoundText =
		'Metric does not exist or you do not have permissions to edit it.';
	protected readonly billingFeature = null;

	override model(params: { horizon_metric_id: string }): HorizonMetric | null {
		return this.mmHorizonMetricsService.findModel(params.horizon_metric_id);
	}

	protected openEditPopup(model: HorizonMetric) {
		return this.mmHorizonMetricsService.openEditPopup(model, 'metrics');
	}
}
